import { clearInputField } from '../../helpers';

export const setupSubjectToLawsRegulationsOrInstructionsFields = ($form) => {
  const $isSubjectToLawsRegulationsOrInstructionsRadio = $('#is_subject_to_laws_regulations_or_instructions_buttons input[type=radio]', $form);
  const $subjectToLawsRegulationsOrInstructionsDetailsField = $('#subject_to_laws_regulations_or_instructions_details_field', $form);

  $isSubjectToLawsRegulationsOrInstructionsRadio.on('change', (e) => {
    if (e.target.checked && e.target.value === 'true') {
      $subjectToLawsRegulationsOrInstructionsDetailsField.removeClass('d-none');
    } else {
      $subjectToLawsRegulationsOrInstructionsDetailsField.addClass('d-none');
      $('input', $subjectToLawsRegulationsOrInstructionsDetailsField).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
};
